$(document).ready(function() {
    var popup_time = document.querySelector('.popup-time');
    $('.popup-time__content__close').click(function() {
        $('.popup-time').removeClass('active');
    });

    $('.popup-time__content__close_text').click(function() {
        $('.popup-time').removeClass('active');
    });
    
    function getCookie(cName) {
        const name = cName + "=";
        const cDecoded = decodeURIComponent(document.cookie); 
        const cArr = cDecoded.split('; ');
        let res;
        cArr.forEach(val => {
            if (val.indexOf(name) === 0) res = val.substring(name.length);
        })
        return res
    }
    if (getCookie("age_confirmation") === "off"  && getCookie('newsletter_subscribed') != "true" && sessionStorage.getItem('popup') != 'off') {
        if((new URLSearchParams(window.location.search).get('utm_medium') || '').toLowerCase() === 'email') { sessionStorage.setItem('popup', 'off'); return};
        if (!popup_time || sessionStorage.getItem('popup') === 'off') return;
        var popupTimeoutId = setTimeout(() => showPopup(), 5000);
        window.addEventListener('scroll', onscroll);
    }
    function onscroll() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollPercent = (scrollTop / docHeight) * 100;
        if (scrollPercent >= 30) showPopup();
    }
    function showPopup() {
        if (!popup_time) return;
        if (popup_time.classList.contains('active')) return;
        if (sessionStorage.getItem('popup') === 'off') return;
        popup_time.classList.add('active');
        window.removeEventListener('scroll', onscroll);
        try { clearTimeout(popupTimeoutId); } catch(e) {}
        sessionStorage.setItem('popup', 'off');
    }

});